import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { AngularFireFunctions } from "@angular/fire/compat/functions";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Network } from "@capacitor/network";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { interval } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { IonicModule } from "@ionic/angular";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-unpause-syndicate-bottomsheet",
    templateUrl: "./unpause-syndicate-bottomsheet.component.html",
    styleUrls: ["./unpause-syndicate-bottomsheet.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        IonicModule,
        MatProgressSpinner,
        MatIcon,
    ],
})
export class UnpauseSyndicateBottomsheetComponent {
  syndicate: any;
  selectedLanguage: any = "en";
  translatedToastMsg: any;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  isOnline: boolean;
  proceed = true;

  constructor(
    private dialogRef: MatDialogRef<UnpauseSyndicateBottomsheetComponent>,
    private angularFireFunctions: AngularFireFunctions,
    public translate: TranslateService,
    private authService: AuthService,
    private syndicateRepositoryService: SyndicateRepositoryService,
    private cdRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.syndicate = data?.syndicate;
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
  }

  closeUnpauseSyndicateDialog() {
    this.dialogRef.close(false);
  }
  unPauseSyndicate() {
    this.syndicateRepositoryService.unPauseSyndicate(this.syndicate?.id ? this.syndicate?.id : this.syndicate?.encrypted_id).subscribe((res) => {
      if (res && res?.status && res?.status.toLowerCase() === "success") {
        this.progressBar = 100;
        if (this.dialogRef) {
          this.dialogRef.close();          
        }
        if (this.sub) {
          this.sub.unsubscribe();          
        }
        /*  const msg = this.translatedToastMsg?.["1099"]?.[this.selectedLanguage];
         this.authService.showToast(msg ? msg : "Syndiate has been unpaused", "Success", ""); */
        this.authService.getConstantsMsg("1101").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: '<span style="font-weight:400">Syndicate has been </span>unpaused',
              line_2: "",
            },
            style: {
              icon: "tick circle success.png",
              type: "Success",
            }
          }
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }).catch((error) => {
          return error;
        });
      } else {
        /*  const msg = this.translatedToastMsg?.["1100"]?.[this.selectedLanguage];
         this.authService.showToast(msg ? msg : "please try again!", "Error", ""); */
        this.authService.getConstantsMsg("1102").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Please try again!",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            }
          }
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }).catch((error) => {
          return error;
        });
        this.dialogRef.close(false);
      }
      setTimeout(() => {
        this.spinnerAnimation = false;
        this.proceed = false;
        setTimeout(() => {
          this.proceed = true;
        }, 2000);
      }, 300);
    });
  }
  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.cdRef.detectChanges();
        // this.modalController.dismiss()
      },
      (err) => {
        return err;
      }
    );
    this.cdRef.detectChanges();
  }
}
